import {
	GET_REFERRAL_REGISTRATION_SUCCESS,
	PUT_REFERRAL_SOLICITOR_SUCCESS,
} from 'stash/actions/api/referrals.js';

const referral_data = (
	state = {
		customLanding: {},
		referralsRegistrationView: {},
		referralsManagementView: {},
	},
	action
) => {
	switch (action.type) {
		case GET_REFERRAL_REGISTRATION_SUCCESS:
			return {
				...state,
				referralsRegistrationView: action.response.referralsRegistrationView,
			};

		case PUT_REFERRAL_SOLICITOR_SUCCESS:
			return {
				...state,
				referralsManagementView: {
					...state.referralsManagementView,
					solicitorAgreement: {
						...state.referralsManagementView.solicitorAgreement,
						isAccepted: true,
					},
				},
			};
		default:
			return state;
	}
};

export default referral_data;
